<!-- Dark -->
<ng-container *ngIf="config.scheme === 'dark'">
    <button
        mat-icon-button
        [matTooltip]="'Light Mode'"
        (click)="setScheme('light')"
    >
        <mat-icon [svgIcon]="'heroicons_solid:moon'"></mat-icon>
    </button>
</ng-container>

<!-- Light -->
<ng-container *ngIf="config.scheme === 'light'">
    <button
        mat-icon-button
        [matTooltip]="'Dark Mode'"
        (click)="setScheme('dark')"
    >
        <mat-icon [svgIcon]="'heroicons_solid:sun'"></mat-icon>
    </button>
</ng-container>
